const MONTH_LABELS = {
  pt: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
  es: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
  en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
};

export const monthValue = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;

export const monthBounds = (value) => {
  const [year, month] = value.split('-').map(Number);
  const from = `${year}-${String(month).padStart(2, '0')}-01`;
  const last = new Date(year, month, 0).getDate();
  const to = `${year}-${String(month).padStart(2, '0')}-${String(last).padStart(2, '0')}`;
  return { from, to };
};

export const recentMonthOptions = (now, language) => {
  const names = MONTH_LABELS[language] || MONTH_LABELS.en;
  return Array.from({ length: 6 }, (_, index) => {
    const date = new Date(now.getFullYear(), now.getMonth() - index, 1);
    return { value: monthValue(date), label: `${names[date.getMonth()]}/${date.getFullYear()}` };
  });
};

export const bulkIssuePayload = ({ bounds, teamMemberIds, customerIds, selectAll, sourceKeys }) => ({
  from: bounds.from,
  to: bounds.to,
  teamMemberIds,
  customerIds,
  selectAll,
  sourceKeys: selectAll ? [] : sourceKeys,
});
